import React from 'react'

export default function SelectField({
  label,
  name,
  options, // Array of { label, value } or array of strings or object { displayLabel: value }
  defaultValue,
  value,
  onChange,
  error,
  helpText,
  required = false,
  placeholder = 'Selecione...',
  className = '',
  selectClassName = ''
}) {
  // Normalize options to array format
  const normalizedOptions = Array.isArray(options)
    ? options.map(opt =>
        typeof opt === 'string'
          ? { label: opt, value: opt }
          : opt
      )
    : Object.entries(options).map(([displayLabel, val]) => ({
        label: displayLabel,
        value: val
      }))

  const isControlled = value !== undefined
  const selectProps = isControlled
    ? { value: value || '', onChange }
    : { defaultValue: defaultValue || '' }

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label htmlFor={name} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        {...selectProps}
        className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light bg-white ${selectClassName}`}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {normalizedOptions.map(({ label: optionLabel, value: optVal }) => (
          <option key={optVal} value={optVal}>
            {optionLabel}
          </option>
        ))}
      </select>
      {helpText && (
        <p className="mt-1 text-gray-500 text-sm">{helpText}</p>
      )}
      {error && (
        <div className="mt-1 text-red-600 text-sm">{error}</div>
      )}
    </div>
  )
}
